<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full max-w-(--breakpoint-sm) justify-center">
            <div class="flex flex-col gap-6">
                <vx-alert v-if="success" type="success" :closeable="false"
                    >Billing Information has been successfully updated</vx-alert
                >

                <billing-information v-model="form" :readOnly="team.status === 'closed'">
                    <template v-slot:header>Billing Information</template>
                </billing-information>

                <vx-sticky-footer>
                    <vx-button href="/kiosk/teams" data-test="cancel-button" class="w-20" size="lg" color="muted">
                        Cancel
                    </vx-button>
                    <vx-button
                        @click="submit()"
                        data-test="submit-button"
                        class="grow"
                        size="lg"
                        color="primary"
                        :loading="submitting"
                        :disabled="team.status === 'closed'"
                    >
                        Update
                    </vx-button>
                </vx-sticky-footer>
            </div>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';
import BillingInformation from '~/components/general/BillingInformation.vue';
import { VxAlert, VxButton, VxStickyFooter } from '@voxie/frontend-components';
import { teamBillingClient } from '~/services';
import { ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { validateRules } from '~/utils/validation';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';

const { team, onMountedTeam } = useTeamDetails();
const { catchError } = useFormRequestHandler();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const form = ref({
    company_legal_name: null,
    address: '',
    address_line_2: null,
    city: '',
    state: '',
    zip: '',
    country: 'US',
    po_number: null,
});

onMountedTeam(() => {
    form.value = {
        company_legal_name: team.value.billing_company_legal_name,
        address: team.value.billing_address,
        address_line_2: team.value.billing_address_line_2,
        city: team.value.billing_city,
        state: team.value.billing_state,
        zip: team.value.billing_zip,
        country: team.value.billing_country,
        po_number: team.value.billing_po_number,
    };
});

const submitting = ref(false);
const success = ref(false);
const validate = useVuelidate();

const submit = async () => {
    if (submitting.value) {
        return;
    }

    submitting.value = true;
    validate.value.$reset();

    if (!(await validateRules(validate))) {
        submitting.value = false;

        return;
    }

    try {
        await teamBillingClient.updateInformation(props.teamId, form.value);

        success.value = true;
    } catch (e) {
        catchError(e);
    } finally {
        submitting.value = false;
    }
};
</script>
